module.exports = __webpack_public_path__ + "static/media/bring-forward.143e224a.svg";